/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getStoneSet = /* GraphQL */ `query GetStoneSet($id: ID!) {
  getStoneSet(id: $id) {
    id
    stones {
      nextToken
      startedAt
      __typename
    }
    title
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStoneSetQueryVariables,
  APITypes.GetStoneSetQuery
>;
export const listStoneSets = /* GraphQL */ `query ListStoneSets(
  $filter: ModelStoneSetFilterInput
  $limit: Int
  $nextToken: String
) {
  listStoneSets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStoneSetsQueryVariables,
  APITypes.ListStoneSetsQuery
>;
export const syncStoneSets = /* GraphQL */ `query SyncStoneSets(
  $filter: ModelStoneSetFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncStoneSets(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      title
      description
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncStoneSetsQueryVariables,
  APITypes.SyncStoneSetsQuery
>;
export const getStone = /* GraphQL */ `query GetStone($id: ID!) {
  getStone(id: $id) {
    id
    setId
    name
    key
    color
    size
    shape
    variant
    img
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    stoneSetStonesId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetStoneQueryVariables, APITypes.GetStoneQuery>;
export const listStones = /* GraphQL */ `query ListStones(
  $filter: ModelStoneFilterInput
  $limit: Int
  $nextToken: String
) {
  listStones(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      setId
      name
      key
      color
      size
      shape
      variant
      img
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      stoneSetStonesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStonesQueryVariables,
  APITypes.ListStonesQuery
>;
export const syncStones = /* GraphQL */ `query SyncStones(
  $filter: ModelStoneFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncStones(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      setId
      name
      key
      color
      size
      shape
      variant
      img
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      stoneSetStonesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncStonesQueryVariables,
  APITypes.SyncStonesQuery
>;
export const getGame = /* GraphQL */ `query GetGame($id: ID!) {
  getGame(id: $id) {
    id
    owner
    sharedWith
    title
    description
    currentPlayer
    board {
      name
      key
      stone {
        name
        key
        color
        size
        shape
        variant
        img
        __typename
      }
      __typename
    }
    currentStone {
      name
      key
      color
      size
      shape
      variant
      img
      __typename
    }
    player1
    player2
    player1UserId
    player2UserId
    gameHasStarted
    expertMode
    winner
    winRow
    iconSet
    stoneSetId
    seriesId
    rejoinedPlayers
    rematchCreated
    rematchId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    gameSeriesGamesId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGameQueryVariables, APITypes.GetGameQuery>;
export const listGames = /* GraphQL */ `query ListGames(
  $filter: ModelGameFilterInput
  $limit: Int
  $nextToken: String
) {
  listGames(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      sharedWith
      title
      description
      currentPlayer
      player1
      player2
      player1UserId
      player2UserId
      gameHasStarted
      expertMode
      winner
      winRow
      iconSet
      stoneSetId
      seriesId
      rejoinedPlayers
      rematchCreated
      rematchId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      gameSeriesGamesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListGamesQueryVariables, APITypes.ListGamesQuery>;
export const syncGames = /* GraphQL */ `query SyncGames(
  $filter: ModelGameFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGames(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      owner
      sharedWith
      title
      description
      currentPlayer
      player1
      player2
      player1UserId
      player2UserId
      gameHasStarted
      expertMode
      winner
      winRow
      iconSet
      stoneSetId
      seriesId
      rejoinedPlayers
      rematchCreated
      rematchId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      gameSeriesGamesId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncGamesQueryVariables, APITypes.SyncGamesQuery>;
export const getGameSeries = /* GraphQL */ `query GetGameSeries($id: ID!) {
  getGameSeries(id: $id) {
    id
    games {
      nextToken
      startedAt
      __typename
    }
    gameIds
    title
    description
    player1
    player2
    player1Wins
    player2Wins
    playerQueue
    seriesMode
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGameSeriesQueryVariables,
  APITypes.GetGameSeriesQuery
>;
export const listGameSeries = /* GraphQL */ `query ListGameSeries(
  $filter: ModelGameSeriesFilterInput
  $limit: Int
  $nextToken: String
) {
  listGameSeries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      gameIds
      title
      description
      player1
      player2
      player1Wins
      player2Wins
      playerQueue
      seriesMode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGameSeriesQueryVariables,
  APITypes.ListGameSeriesQuery
>;
export const syncGameSeries = /* GraphQL */ `query SyncGameSeries(
  $filter: ModelGameSeriesFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncGameSeries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      gameIds
      title
      description
      player1
      player2
      player1Wins
      player2Wins
      playerQueue
      seriesMode
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncGameSeriesQueryVariables,
  APITypes.SyncGameSeriesQuery
>;
export const getPlayerState = /* GraphQL */ `query GetPlayerState($id: ID!) {
  getPlayerState(id: $id) {
    id
    gameList
    playerAssignments
    preferences
    dismissedClaims
    playerNickname
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlayerStateQueryVariables,
  APITypes.GetPlayerStateQuery
>;
export const listPlayerStates = /* GraphQL */ `query ListPlayerStates(
  $filter: ModelPlayerStateFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlayerStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      gameList
      playerAssignments
      preferences
      dismissedClaims
      playerNickname
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlayerStatesQueryVariables,
  APITypes.ListPlayerStatesQuery
>;
export const syncPlayerStates = /* GraphQL */ `query SyncPlayerStates(
  $filter: ModelPlayerStateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPlayerStates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      gameList
      playerAssignments
      preferences
      dismissedClaims
      playerNickname
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPlayerStatesQueryVariables,
  APITypes.SyncPlayerStatesQuery
>;
